<template>
  <text-field-like
      :value="value"
      :value-id="valueId"
      :value-hds-id="valueHdsId"
      :message="message"
      :label="label"
      :flat="flat"
      :hide-details="hideDetails"
      :loading="loading"
      :color="color"
      :prepend-icon="prependIcon"
      :append-icon="appendIcon"
      :dense="dense">
    <template #default="{value}">
      <local-id-box
          :value="value">
      </local-id-box>
    </template>
    <template #prepend>
      <slot name="prepend"></slot>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </text-field-like>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import LocalIdBox from "@/components/molecules/LocalIdBox.vue";

export default {
  name: "LocalIdField",
  components: {LocalIdBox, TextFieldLike},
  props: {
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String
    },
    appendIcon: {
      type: String
    },
    valueId: {
      type: String
    },
    valueHdsId: {
      type: String
    },
    message: {
      type: String
    },
  },
}
</script>

<style scoped>

</style>
